import { Controller } from "@hotwired/stimulus";
import { marked } from "marked";
import { DirectUpload } from '@rails/activestorage';

export default class extends Controller {

  static targets = ["viewer","markup"];

  connect() {
    this.viewerTarget.innerHTML = marked(this.markup.value, { sanitized: true });

    this.markup.addEventListener("keydown", function(e) {
      var TABKEY = 9;
      if(e.keyCode == TABKEY) {
        var startPosition = this.selectionStart;
        var endPosition = this.selectionEnd;
        var text = "\t";

        if (startPosition == endPosition) {
          this.value = this.value.substring(0, startPosition) + text + this.value.substring(endPosition, this.value.length);
          this.selectionStart = startPosition + text.length;
          this.selectionEnd = startPosition + text.length;
        }

        if(e.preventDefault) {
          e.preventDefault();
        }
        return false;
      }
    }, false);
  }

  convertToMarkdown(event) {
    this.viewerTarget.innerHTML = marked(event.target.value, {sanitized: true});
  }

  trigger(){
    var chg = new Event('change',{ bubbles: true });
    this.markup.dispatchEvent(chg);
  }


  h1() {
    var selected = this.markup.value.substring(this.range.start,this.range.end);
    this.insert('\n# '+selected);
  }

  h2() {
    var selected = this.markup.value.substring(this.range.start,this.range.end);
    this.insert('\n## '+selected + ' ');
  }

  h3() {
    var selected = this.markup.value.substring(this.range.start,this.range.end);
    this.insert('\n### '+selected);
  }

  bold() {
    this.wrap('**');
  }

  italic() {
    this.wrap('*');
  }

  backTick(){
    this.wrap('`');
  }

  ul() {
    var selected = this.markup.value.substring(this.range.start,this.range.end);
    selected = "\n* " + selected.replace(/\n/g,"\n* ");
    this.insert(selected);
  }

  ol() {
    var selected = this.markup.value.substring(this.range.start,this.range.end);
    selected = "\n1. " + selected.replace(/\n/g,"\n1. ");
    this.insert(selected);
  }

  fencedCode(){
    var selected = this.markup.value.substring(this.range.start,this.range.end);
    selected = "```lang\n " + selected + "\n```";
    this.insert(selected);
  }

  anchor(){
    var selected = this.markup.value.substring(this.range.start,this.range.end);
    selected = "[" + selected + "]" + '(http://...)';
    this.insert(selected);
  }

  image(){
    var selected = this.markup.value.substring(this.range.start,this.range.end);
    selected = "![" + selected + "]" + '(path/to/img.jpg)';
    this.insert(selected);
  }

  upload(event) {
    event.preventDefault();

    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.multiple = true;
    fileInput.accept = 'image/*';

    fileInput.addEventListener('change', (e) => {
      Array.from(e.target.files).forEach((file) => this.uploadFile(file));
    });

    fileInput.click();
  }

  uploadFile(file) {
    const upload = new DirectUpload(file,"/rails/active_storage/direct_uploads");

    upload.create((error, blob) => {
      if (error) {
        console.log('Error', error);
      } else {
        var link = this.pathFromBlob(blob);
        this.insert(`![${blob.filename}](${link})`);
      }
    });
  }

  pathFromBlob(blob) {
    return `${this.baseUrl()}/rails/active_storage/blobs/redirect/${blob.signed_id}/${encodeURIComponent(blob.filename)}`;
  }

  baseUrl() {
    return `${window.Rails.application.scheme}://${window.Rails.application.host}`;
  }

  backQuote(){
    var selected = this.markup.value.substring(this.range.start,this.range.end);
    selected = ">" + selected;
    this.insert(selected);
  }

  get markup() {
    return this.markupTarget;
  }

  get range(){
    return this.getInputSelection(this.markup);
  }

  insert(selected){
    const len = this.markup.value.length;
    this.markup.value = this.markup.value.substring(0,this.range.start) + selected + this.markup.value.substring(this.range.end,len);
    this.trigger();
  }

  wrap(wrapper){
    const len = this.markup.value.length;
    const wrapie = wrapper + this.markup.value.substring(this.range.start,this.range.end) + wrapper;
    this.markup.value = this.markup.value.substring(0,this.range.start) + wrapie + this.markup.value.substring(this.range.end,len);
    this.trigger();
  }

  getInputSelection(el) {
    var start = 0, end = 0, normalizedValue, range, textInputRange, len, endRange;

    if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
      start = el.selectionStart;
      end = el.selectionEnd;
    } else {
      range = document.selection.createRange();

      if (range && range.parentElement() == el) {
        len = el.value.length;
        normalizedValue = el.value.replace(/\r\n/g, "\n");
        // Create a working TextRange that lives only in the input
        textInputRange = el.createTextRange();
        textInputRange.moveToBookmark(range.getBookmark());
        // Check if the start and end of the selection are at the very end
        // of the input, since moveStart/moveEnd doesn't return what we want
        // in those cases
        endRange = el.createTextRange();
        endRange.collapse(false);

        if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
          start = end = len;
        } else {
          start = -textInputRange.moveStart("character", -len);
          start += normalizedValue.slice(0, start).split("\n").length - 1;

          if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
              end = len;
          } else {
              end = -textInputRange.moveEnd("character", -len);
              end += normalizedValue.slice(0, end).split("\n").length - 1;
          }
        }
      }
    }

    return {
      start: start,
      end: end
    };
  }

}